export type NodeShape = "rect" | "diamond";
export type NodeColor = "blue" | "green" | "purple" | "orange" | "yellow";

export interface FlowchartNode {
  id: string;
  label: string[];
  shape: NodeShape;
  color: NodeColor;
}

export interface FlowchartEdge {
  from: string;
  to: string;
  label?: string;
}

export interface FlowchartData {
  title: string;
  nodes: FlowchartNode[];
  edges: FlowchartEdge[];
}

const VALID_SHAPES: NodeShape[] = ["rect", "diamond"];
const VALID_COLORS: NodeColor[] = ["blue", "green", "purple", "orange", "yellow"];

export function parseFlowchartBlock(jsonStr: string): FlowchartData | null {
  try {
    const raw = JSON.parse(jsonStr);

    if (
      typeof raw.title !== "string" ||
      !Array.isArray(raw.nodes) ||
      raw.nodes.length === 0 ||
      !Array.isArray(raw.edges)
    )
      return null;

    for (const node of raw.nodes) {
      if (
        typeof node.id !== "string" ||
        !Array.isArray(node.label) ||
        node.label.length === 0 ||
        !VALID_SHAPES.includes(node.shape) ||
        !VALID_COLORS.includes(node.color)
      )
        return null;
    }

    for (const edge of raw.edges) {
      if (typeof edge.from !== "string" || typeof edge.to !== "string")
        return null;
    }

    return {
      title: raw.title,
      nodes: raw.nodes,
      edges: raw.edges,
    };
  } catch {
    return null;
  }
}
